export const AllowCountryList = new Set([
  "AE", // United Arab Emirates
  "AT", // Austria
  "AU", // Australia
  "BE", // Belgium
  "BR", // Brazil
  "CA", // Canada
  "CH", // Switzerland
  "DE", // Germany
  "ES", // Spain
  "FI", // Finland
  "FR", // France
  "GB", // United Kingdom
  "IN", // India
  "IT", // Italy
  "JP", // Japan
  "LU", // Luxembourg
  "MX", // Mexico
  "NL", // The Netherlands
  "NO", // Norway
  "SA", // Kingdom of Saudi Arabia
  "SE", // Sweden
  "TR", // Turkey
  "US", // United States
]);
